import * as TooltipPrimitive from '@radix-ui/react-tooltip'

interface FieldTooltipProps {
  content: string;
  /** Optional: override the trigger icon. Defaults to 'info'. */
  icon?: string;
}

export function FieldTooltip({ content, icon = 'info' }: FieldTooltipProps) {
  return (
    <TooltipPrimitive.Root>
      <TooltipPrimitive.Trigger asChild>
        <button
          type="button"
          className="ml-1 inline-flex items-center align-middle transition-colors focus:outline-none focus-visible:ring-1 focus-visible:ring-[#0078d4] rounded-sm"
          style={{ color: 'var(--text-tertiary)' }}
          onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--text-secondary)')}
          onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--text-tertiary)')}
          aria-label={content}
        >
          <span className="material-symbols-outlined text-[15px]">{icon}</span>
        </button>
      </TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          sideOffset={6}
          className="z-[100] max-w-[260px] rounded px-3 py-2 text-[12px] leading-snug shadow-lg"
          style={{
            backgroundColor: 'var(--surface-container-highest)',
            color: 'var(--text-primary)',
            border: '1px solid var(--outline-variant)',
          }}
        >
          {content}
          <TooltipPrimitive.Arrow style={{ fill: 'var(--surface-container-highest)' }} />
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  )
}
